export default "__VITE_ASSET__Csyx3E4Q__"